module.exports = __webpack_public_path__ + "img/ins.6ce182a0.png";